module.exports = __webpack_public_path__ + "img/fengqiuAppImage.cc2b8eb9.png";